
import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import { CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { AnimatedCard } from '@/components/ui/AnimatedCard';
import { voltageData, amperageData } from '@/data/energy-analytics-data';

const PowerQualityCharts = () => {
  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
      <AnimatedCard 
        animation="fade-up"
        className="bg-white dark:bg-gray-800 border-none"
      >
        <CardHeader>
          <CardTitle>Voltage Monitoring (V)</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="h-80">
            <ResponsiveContainer width="100%" height="100%">
              <LineChart data={voltageData}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="time" />
                <YAxis domain={[210, 240]} />
                <Tooltip 
                  formatter={(value) => [`${value}V`, 'Voltage']}
                  contentStyle={{ 
                    borderRadius: '8px', 
                    border: 'none', 
                    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)' 
                  }}
                />
                <Line 
                  type="monotone" 
                  dataKey="voltage" 
                  stroke="#FF453A" 
                  dot={{ r: 3 }}
                  activeDot={{ r: 5 }}
                />
              </LineChart>
            </ResponsiveContainer>
          </div>
        </CardContent>
      </AnimatedCard>
      
      <AnimatedCard 
        animation="fade-up"
        delay={100}
        className="bg-white dark:bg-gray-800 border-none"
      >
        <CardHeader>
          <CardTitle>Amperage Monitoring (A)</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="h-80">
            <ResponsiveContainer width="100%" height="100%">
              <LineChart data={amperageData}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="time" />
                <YAxis />
                <Tooltip 
                  formatter={(value) => [`${value}A`, 'Amperage']}
                  contentStyle={{ 
                    borderRadius: '8px', 
                    border: 'none', 
                    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)' 
                  }}
                />
                <Line 
                  type="monotone" 
                  dataKey="amperage" 
                  stroke="#5AC8FA" 
                  dot={{ r: 3 }}
                  activeDot={{ r: 5 }}
                />
              </LineChart>
            </ResponsiveContainer>
          </div>
        </CardContent>
      </AnimatedCard>
    </div>
  );
};

export default PowerQualityCharts;
